import { render, staticRenderFns } from "./igt-settings.vue?vue&type=template&id=0ecfcf36&scoped=true&"
import script from "./igt-settings.vue?vue&type=script&lang=js&"
export * from "./igt-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecfcf36",
  null
  
)

export default component.exports